import { useDispatch } from 'react-redux';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { readNotification } from 'features/notification/notificationSlice';

const ReadNotification = (props) => {
  const dispatch = useDispatch();

  const shortDescription = props.notification
    ? props.notification.short_description
    : '';
  const longDescription = props.notification
    ? props.notification.long_description
    : '';
  const isAlreadyRead = props.notification ? props.notification.read : true; // don't try to mark as read if no notification

  const updateNotification = async () => {
    if (!isAlreadyRead) {
      await dispatch(readNotification(props.notification));
    }
    props.handleClose(false);
  };

  return (
    <>
      <Dialog
        open={props.open}
        onClose={() => props.handleClose()}
        aria-labelledby='form-dialog-title'
      >
        <DialogTitle id='form-dialog-title'>{shortDescription}</DialogTitle>
        <DialogContent>
          <DialogContentText>{longDescription}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => updateNotification()} color='primary'>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReadNotification;
